import TariffComp from '../components/tariffComp'
import './tariff.css'
import { useEffect } from 'react';

export default function Tariff(){

    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    return(
        <div className='wrapper tariffPage'>
            <h2 className='tariffPageTitle'>Our <span>Tariff</span></h2>
            <TariffComp/>
            <div className='tariffPackage package'>
                <h2>Our <span>Tour Package</span></h2>
                <figure>
                    <img src='./images/pack1.png' alt='Tirupati'/>
                    <img src='./images/pack2.png' alt='Velangani'/>
                    <img src='./images/pack3.png' alt='Tirupati'/>
                    <img src='./images/pack4.png' alt='Chennai'/>
                </figure>
                <a href='/' className='Btn packageBtn'>Book Now</a>
            </div>
        </div>
    )
}